import Logo from "./logo/logo.png";
import LoginBg from "./MCA/LoginBg.png";
import DesktopLoginBg from "./MCA/DesktopLoginBg.svg";
import HeaderBg from "./Splash/headerBg.png";
import Bg from "./Splash/Bg.png";
import mcaLogo from "./logo/mca-logo.png";
import contactSuccessImg from "./contact-success.png";
import pdfIcon from "./Icons/pdfIcon.svg";
import dskLogo from "./logo/dskLogo.png";
import auctionBg from "./auction/auctionbg.png";
import auctionnewBg from "./admin/auctionbg.png";
import teamLogo from "./auction/teamLogo.png";
import player from "./auction/player.png";
import player1 from "./auction/player1.png";
import fallbackProfile from "./auction/fallbackprofile.jpg";
import playerBg from "./auction/playerBg.png";
import profile from "./auction/profile.png";
import profile2 from "./auction/profile2.png";
import soldArrow from "./auction/soldArrow.png";
import hash from "./auction/hash.svg";
import playerTeamLogo from "./auction/playerTeamLogo.png";
import t20Logo from "./auction/t20Logo.png";
import playerDetailsBg from "./auction/playerDetailsBg.svg";
import tableHeaderBg from "./auction/tableHeaderBg.svg";
import tableBasePriceBg from "./auction/tableBasePriceBg.svg";
import teamDetailsHeaderBg from "./auction/teamDetailsHeaderBg.svg";
import mcaI20Logo from "./logo/mcaI20Logo.svg";
import bidResultBg from "./auction/auctionResultBg.svg";
import liveBidBg from "./auction/liveBidNameBg.svg";
import IconPlayer1 from "./auction/iconPlayers/IconPlayer1.png";
import IconPlayer2 from "./auction/iconPlayers/IconPlayer2.png";
import IconPlayer3 from "./auction/iconPlayers/IconPlayer3.png";
import IconPlayer4 from "./auction/iconPlayers/IconPlayer4.png";
import IconPlayer5 from "./auction/iconPlayers/IconPlayer5.png";
import IconPlayer6 from "./auction/iconPlayers/IconPlayer6.png";
import IconPlayer7 from "./auction/iconPlayers/IconPlayer7.png";
import IconPlayer8 from "./auction/iconPlayers/IconPlayer8.png";
import teamPurseBg from "./auction/teamPurseBg.png";
import spikeTL from "./auction/elements/spikeTL.svg";
import spikeTR from "./auction/elements/spikeTR.svg";
import spikeBL from "./auction/elements/spikeBL.svg";
import spikeBR from "./auction/elements/spikeBR.svg";
import shape1BL from "./auction/elements/shape1BL.svg";
import shape1BR from "./auction/elements/shape1BR.svg";
import shape2BR from "./auction/elements/shape2BR.svg";
import shape2TL from "./auction/elements/shape2TL.svg";
import squadBg from "./auction/squadBg.png";
import fundRemainingBg from "./auction/fundRemainingBg.png";
import squadPlayerBg from "./auction/squadPlayerBg.png";
import ballIcon from "./auction/icons/ballIcon.svg";
import batIcon from "./auction/icons/batIcon.svg";
import keeperIcon from "./auction/icons/keeperIcon.svg";
import HashBlue from "./auction/hashBlue.png";
import allRounderIcon from "./auction/icons/allRounderIcon.svg";
import battingIcon from "./auction/player/batting.svg";
import bowlingIcon from "./auction/player/bowling.svg";
import fieldIcon from "./auction/player/field.svg";
import icon50Scores from "./auction/player/50+ Scores.svg";
import iconBBIW from "./auction/player/BBIW.svg";
import iconDot from "./auction/player/Dot.svg";
import iconEconomy from "./auction/player/Economy.svg";
import iconFourWickets from "./auction/player/Fourwickets.svg";
import iconHS from "./auction/player/HS.svg";
import iconInnings from "./auction/player/Innings.svg";
import iconMatches from "./auction/player/Matches.svg";
import iconOvers from "./auction/player/Overs.svg";
import iconRuns from "./auction/player/Runs.svg";
import iconSR from "./auction/player/SR.svg";
import headerBadge from "./auction/elements/headerBadge.svg";
import adminTeamBg from "./admin/adminTeamBg.png";
import teamCardElement from "./admin/teamCardElement.png";
import teamCardRoundElement from "./admin/teamCardRoundElement.png";

export * from "./register";
const default_Photo = fallbackProfile;

export {
  HashBlue,
  allRounderIcon,
  battingIcon,
  bowlingIcon,
  fieldIcon,
  icon50Scores,
  iconBBIW,
  iconDot,
  iconEconomy,
  iconFourWickets,
  iconHS,
  iconInnings,
  iconMatches,
  iconOvers,
  iconRuns,
  iconSR,
  headerBadge,
  adminTeamBg,
  teamCardElement,
  teamCardRoundElement,
  Logo,
  contactSuccessImg,
  mcaLogo,
  LoginBg,
  HeaderBg,
  Bg,
  DesktopLoginBg,
  pdfIcon,
  dskLogo,
  auctionBg,
  auctionnewBg,
  teamLogo,
  player,
  player1,
  playerBg,
  profile,
  profile2,
  soldArrow,
  hash,
  playerTeamLogo,
  t20Logo,
  playerDetailsBg,
  tableHeaderBg,
  tableBasePriceBg,
  teamDetailsHeaderBg,
  mcaI20Logo,
  bidResultBg,
  default_Photo,
  liveBidBg,
  IconPlayer1,
  IconPlayer2,
  IconPlayer3,
  IconPlayer4,
  IconPlayer5,
  IconPlayer6,
  IconPlayer7,
  IconPlayer8,
  teamPurseBg,
  spikeTL,
  spikeTR,
  spikeBL,
  spikeBR,
  shape1BL,
  shape1BR,
  shape2BR,
  shape2TL,
  squadBg,
  fundRemainingBg,
  squadPlayerBg,
  ballIcon,
  batIcon,
  keeperIcon,
};
